import React from "react";
import Modal from "../Modal";
import GeneratedVideoDetail from "../videos/GeneratedVideoDetail";

const BrandVideoDetailModal = ({
  videoHash,
  initialVideo,
  brandHash,
  onClose,
}) => (
  <Modal onClose={onClose} maxWidth="max-w-3xl" heightClass="h-auto max-h-[90vh]">
    <GeneratedVideoDetail
      videoHash={videoHash}
      initialVideo={initialVideo}
      brandHash={brandHash}
    />
  </Modal>
);

export default BrandVideoDetailModal;
